export default __webpack_public_path__ + "static/media/keto-bars@2x.48e25f4d.png";